import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from, map, switchMap } from 'rxjs';
import { ApiUrlService } from '../services/api-url.service';
import { AuthService } from '../services/auth.service';
import { User, UsersApiResponse } from './user.interface';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly httpOptions = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };

  constructor(
    private http: HttpClient,
    private apiUrlService: ApiUrlService,
    private authService: AuthService
  ) {}

  getUsers(): Observable<User[]> {
    return from(this.authService.getUser()).pipe(
      switchMap(user => {
        if (!user) {
          throw new Error('User not authenticated');
        }

        if (user.userType !== 'admin') {
          throw new Error('Access denied: Admin privileges required');
        }

        const options = this.apiUrlService.isUsingLocalServer() ? this.httpOptions : {};
        const baseUrl = this.apiUrlService.buildApiUrl('admin');
        
        return this.http.get<UsersApiResponse>(`${baseUrl}/users?limit=100`, options).pipe(
          map(response => {
            if (response.data && response.data.users) {
              return response.data.users;
            }
            return [];
          })
        );
      })
    );
  }
}
